import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function upsertDesignLayout(payload) {
  return mutate(
    {
      designLayouts: [payload],
    },
    gql`
      mutation Upsert_design_layouts($designLayouts: [design_layouts_input]) {
        upsert_design_layouts(design_layouts: $designLayouts) {
          id
          design_json
        }
      }
    `,
  )
}

export async function upsertDesignLayoutConfigurationOptions(payload) {
  return mutate(
    {
      designLayoutConfigurationOptions: [payload],
    },
    gql`
      mutation Upsert_design_layouts_configuration_options(
        $designLayoutConfigurationOptions: [design_layouts_configuration_options_input]
      ) {
        upsert_design_layouts_configuration_options(
          design_layout_configuration_options: $designLayoutConfigurationOptions
        ) {
          id
        }
      }
    `,
  )
}

export async function deleteDesignLayout(id) {
  return mutate(
    {
      deleteDesignLayoutsId: id,
    },
    gql`
      mutation Delete_design_layouts($deleteDesignLayoutsId: Int!) {
        delete_design_layouts(id: $deleteDesignLayoutsId) {
          id
        }
      }
    `,
  )
}

export async function getDesignLayout(id) {
  return await query({
    query: gql`
      query Design_layouts($filters: all_design_layouts_filters) {
        design_layouts(filters: $filters) {
          id
          design_json
          package {
            id
            display_name
          }
        }
      }
    `,
    variables: {
      filters: {
        design_layouts: {
          ids: [id],
        },
      },
    },
  })
}

export async function getDesignLayoutsConfigurationOptionsFields() {
  const { data } = await query(gql`
    query {
      __type(name: "design_layouts_configuration_options") {
        fields {
          name
          type {
            name
            kind
          }
        }
      }
    }
  `)
  return data.__type.fields.filter((f) => f.name !== '__typename')
}
